// const prefix = '/purchaser'

export const name = 'customer-api-config'

export const api = {
  company: {
    getCompanyInfo: `/tax/admin/org/company/info/:id` // get /:companyId
  },
  mobile: {
    getSmartTitles: `/api/v2/basic/titlematch` // get
  },
  buyer: {
    preOrder: `/api/v2/basic/wait/add` // post
  }
}
